import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Tick from '@pqina/flip';

import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { CountdownFlipClockData } from './countdown-flip-clock.interface';
import { LazyLoaderService } from '@finder/shared/services/lazy-loader/lazy-loader-service';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'finder-countdown-flip-clock',
    templateUrl: './countdown-flip-clock.component.html',
    styleUrls: ['./countdown-flip-clock.component.scss'],
    standalone: true,
    imports: [
        CommonModule
    ]
})
export class CountdownFlipClockComponent implements OnInit {
    @Input() data: CountdownFlipClockData;
    @Output() flipUpdate = new EventEmitter<any>();
    @Output() flipEnded = new EventEmitter<any>();

    private tickInstance;
    private tickDate;

    constructor(
        private windowRef: WindowRef,
        private elementRef: ElementRef,
        private lazyLoader: LazyLoaderService,
    ) {}

    ngOnInit() {
        this.attachAssets();
        this.initFlip();
    }

    private attachAssets() {
        const doc = this.windowRef.nativeWindow.document;
        this.lazyLoader.lazyLoadCssResource('/advanced-finder/styles/flip.min.css', false);
        this.lazyLoader.lazyLoadScriptResource('/advanced-finder/scripts/flip.min.js', false);
    }

    private initFlip() {
        // Get existing template divs
        const flipDiv = this.elementRef.nativeElement.firstChild;

        // Set date from data
        const dataValue = this.data?.value;
        this.tickDate = new Date(dataValue);

        // Create the tick element
        this.tickInstance = Tick.DOM.create(flipDiv);

        // Set labels
        const labels = this.data?.labels;
        Object.keys(labels).forEach(key => {
            this.tickInstance.setConstant(key, labels[key]);
        });

        // Set the countdown and add the listeners
        const countdown = Tick.count.down(this.tickDate, { format: this.data?.format });
        countdown.onupdate = (value) => {
            this.tickInstance.value = value;
            this.flipUpdate.emit(value);
        };
        countdown.onended = () => {
            this.flipEnded.emit(true);
        };
    }
}
